export default __webpack_public_path__ + "static/media/Kartik.cb3cb0a0.jpeg";